import { cleanClass } from '@shared/utils/cleanClass.js';

const PageWrapperWithPanes = ({ children = null, left = null, right = null, stickyRight = false, topRight = null, name = '', leftPaneOnTop = false, fixedLeft = false }) => {
  const rightPaneStyles = stickyRight ? { position: 'sticky', top: 32, right: 0, alignSelf: 'flex-start' } : {};

  return (
    <div className={cleanClass(`comp-page-wrapper with-panes ${name} ${fixedLeft ? 'fixed-left' : ''}`)}>
      {left && <div className={cleanClass(`panes-left ${leftPaneOnTop ? 'top' : ''}`)}>{left}</div>}
      <div className="panes-content">{children}</div>
      {right && (
        <div className="panes-right-wrapper">
          {topRight && <div className="panes-top-right">{topRight}</div>}
          <div className="panes-right" style={rightPaneStyles}>
            {right}
          </div>
        </div>
      )}
    </div>
  );
};

export default PageWrapperWithPanes;
